<template>
  <div id="app-root">
    <router-view />
  </div>
</template>

<script>
import { applySiteBranding, fetchSiteBranding } from '@/utils/siteBranding'

export default {
  name: 'App',
  watch: {
    '$i18n.locale'(locale) {
      fetchSiteBranding().then(branding => applySiteBranding(branding, locale))
    }
  }
}
</script>
